<template>
    <article class="product-list-item card" :data-testing="item.variation.id">
        <div class="card-body">
            <div :class="paddingClasses" :style="paddingInlineStyles">
                <div class="product-image-wrapper">
                    <slot name="item-image">
                        <a :href="item | itemURL(urlWithVariationId)">
                            <lazy-img
                                picture-class="product-image"
                                :image-url="categoryVariationImages.urlMiddle"
                                :alt="item.texts.name1"
                                :title="item.texts.name1">
                            </lazy-img>
                        </a>
                    </slot>
                </div>

                <div v-if="isLoadingVariations" class="thumb-content__loading">Lade...</div>
                <div class="swiper-outer-container swiper-outer-container-thumb-swiper" v-if="variations && variations.length > 0" ref="thumbSwiperOuter">
                    <div class="swiper-container category-item__thumb-swiper" ref="thumbSwiper">
                        <div class="swiper-wrapper" :class="{'swiper-wrapper__center' : variations && variations.length < 3 }">
                            <div class="swiper-slide" v-for="variation in variations">
                                <a :href="item | itemURL(urlWithVariationId)">
                                    <img width="43" height="43" :alt="item | itemName" :data-src="variation.previewImage.url" class="swiper-lazy"
                                         @mouseover="mouseOverThumbImage($event.target)" :image="variation.bigImage.url">
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="category-item__thumb-swiper-prev" v-if="variations && variations.length > 3"><i class="fa fa-angle-left"></i></div>
                    <div class="category-item__thumb-swiper-next" v-if="variations && variations.length > 3"><i class="fa fa-angle-right"></i></div>
                </div>

                <slot name="store-special">
                    <item-store-special v-if="storeSpecial || item.variation.bundleType === 'bundle' || item.item.itemType === 'set'"
                                        :store-special="storeSpecial"
                                        :recommended-retail-price="item.prices.rrp"
                                        :variation-retail-price="item.prices.default"
                                        :special-offer-price="item.prices.specialOffer"
                                        :decimal-count="decimalCount"
                                        :bundle-type="item.variation.bundleType"
                                        :item-type="item.item.itemType">
                    </item-store-special>
                </slot>


                <!-- ITEM DETAILS -->
                <slot name="item-details">
                    <div class="product-info">
                        <a :href="item | itemURL(urlWithVariationId)" class="product-name">
                            {{ item | itemName }}<!--
                        --><span v-for="attribute in item.groupedAttributes">{{ "Ceres::Template.itemGroupedAttribute" | translate(attribute) }}</span>
                        </a>

                        <slot name="before-prices"></slot>

                        <div class="price-buy-wrapper">
                            <div class="product-price" :class="{'product-price--sale': item.prices.rrp && item.prices.rrp.price.value > 0 && item.prices.rrp.price.value > item.prices.default.unitPrice.value}">
                                <template v-if="item.item.itemType === 'set'">
                                    {{ $translate("Ceres::Template.itemSetPrice", { price: itemSetPrice }) }}*
                                </template>
                                <template v-else-if="!!item.item && item.item.salableVariationCount > 1 && $ceres.isCheapestSorting" >
                                        {{ $translate("Ceres::Template.categoryItemFromPrice", { price: itemPrice }) }}*
                                </template>
                                <template v-else>
                                    {{ item.prices.default.unitPrice.formatted | specialOffer(item.prices, "unitPrice", "formatted") }}*
                                </template>

                                <template v-if="item.prices.rrp && item.prices.rrp.price.value > 0 && item.prices.rrp.price.value > item.prices.default.unitPrice.value">
                                    <span class="product-price--uvp" v-if="item.prices.specialOffer">
                                        {{ item.prices.default.unitPrice.formatted}}
                                    </span>
                                    <span class="product-price--uvp" v-else>
                                        {{ item.prices.rrp.unitPrice.formatted }}
                                    </span>
                                </template>
                            </div>

                            <slot name="after-prices"></slot>

                            <div class="wishlist-buy">
                                <category-add-wishlist :item-id="item.variation.id"></category-add-wishlist>
                                <add-to-basket
                                        data-testing="item-add-to-basket"
                                        :variation-id="item.variation.id"
                                        :is-salable="!!item.filter && item.filter.isSalable"
                                        :has-children="!!item.item && item.item.salableVariationCount > 1"
                                        :interval-quantity="item.variation.intervalOrderQuantity || 1"
                                        :minimum-quantity="item.variation.minimumOrderQuantity"
                                        :maximum-quantity="!!item.variation.maximumOrderQuantity && item.variation.maximumOrderQuantity > 0 ? item.variation.maximumOrderQuantity : null"
                                        :order-properties="item.properties.filter(function(prop) { return prop.property.isOderProperty })"
                                        :has-order-properties="item.hasOrderProperties"
                                        :use-large-scale="false"
                                        :show-quantity="false"
                                        :item-url="item | itemURL(urlWithVariationId)"
                                        :has-price="item | hasItemDefaultPrice"
                                        :item-type="item.item.itemType">
                                </add-to-basket>
                            </div>
                        </div>
                    </div>
                </slot>
                <!-- ./ITEM DETAILS  -->
            </div>
        </div>
    </article>
</template>

<script>
import { mapState } from "vuex";
import Swiper from "swiper";
import {isNullOrUndefined} from "ceres/app/helper/utils";

import ItemStoreSpecial from "~/app/components/itemList/ItemStoreSpecial.vue";
import ApiService from "../../../../../../node_modules/Ceres/resources/js/src/app/services/ApiService";

export default {
    components: {
        ItemStoreSpecial
    },

    props: {
        decimalCount:
        {
            type: Number,
            default: 0
        },
        imageUrlAccessor:
        {
            type: String,
            default: "urlMiddle"
        },
        itemData:
        {
            type: Object
        },
        disableCarouselOnMobile:
        {
            type: Boolean
        },
        paddingClasses:
        {
            type: String,
            default: null
        },
        paddingInlineStyles:
        {
            type: String,
            default: null
        },
        forceUrlWithVariationId:
        {
            type: Boolean,
            default: false
        }
    },

    jsonDataFields: [
        "itemDataRef"
    ],

    computed:
    {
        currentCatUrl() {

            if(!isNullOrUndefined(this.currentCategory)) {

                const currentCategory = this.navigationTree.find(item => item.id === this.currentCategory.id);

                if(!isNullOrUndefined(currentCategory)) {
                    return currentCategory.url;
                }
            }

            return false;
        },


        item()
        {
            return this.itemData || this.itemDataRef;
        },

        /**
         * returns itemData.item.storeSpecial
         */
        storeSpecial()
        {
            return this.item.item.storeSpecial;
        },

        /**
         * returns itemData.texts
         */
        texts()
        {
            return this.item.texts;
        },

        itemPrice()
        {
            return this.$options.filters.specialOffer(this.item.prices.default.unitPrice.formatted, this.item.prices, "unitPrice", "formatted" );
        },

        itemSetPrice()
        {
            return this.$options.filters.currency(
                this.item.prices.default.price.value,
                this.item.prices.default.currency
            );
        },

        urlWithVariationId()
        {
            return !this.$ceres.config.item.showPleaseSelect || this.$ceres.initialPleaseSelect == 0 || this.forceUrlWithVariationId;
        },

        ...mapState({
            showNetPrices: state => state.basket.showNetPrices
        }),

      categoryVariationImages(){
        if ( this.item.images.variation.length > 0) {
            return this.item.images.variation[0]
        }

        return this.item.images.all[0]
      },

        ...mapState({
            navigationTree: state => state.navigation.tree,
            currentCategory: state => state.navigation.currentCategory
        })

    },

    mounted()
    {
        this.$nextTick(() =>
        {
            this.loadVariationImages();
            this.initialItemId = this.item.item.id;
        });
    },

    data(){
        return {
            variations: {},
            variationsMap: [],
            isLoadingVariations: false,
            showItemModal: false,
            pluginPath: App.pluginPath,
            attributesMap: [],
            initialItemId: 0,
            qty:1,
            currentUrl: this.currentCatUrl,
        }
    },


    methods:{
        orderByPosition(list)
        {
            return list.sort(
                (entryA, entryB) =>
                {
                    if (entryA.position > entryB.position)
                    {
                        return 1;
                    }
                    if (entryA.position < entryB.position)
                    {
                        return -1;
                    }

                    return 0;
                });
        },

        loadVariationImages(){

            this.isLoadingVariations = true;

            ApiService.get("/rest/ODKahu/itemlist?itemId="+ this.item.item.id)
                .done(data => {

                    this.variations = data.itemList;
                    this.variationsMap = data.variationsMap;

                    if(this.variations.length > 0){
                        for(let key in this.variations){
                            if(this.variations.hasOwnProperty(key) && this.variations[key].documents.length > 0){
                                let previewImages = this.orderByPosition(this.$options.filters.itemImages(
                                    this.variations[key].documents[0].data.images,
                                    "urlPreview"
                                )).slice(0, 1);

                                this.variations[key].previewImage = previewImages[0];

                                let bigImages = this.orderByPosition(this.$options.filters.itemImages(
                                    this.variations[key].documents[0].data.images,
                                    "urlMiddle"
                                )).slice(0, 1);

                                this.variations[key].bigImage = bigImages[0];
                            }
                        }
                    }


                    // anpassen des variationsArrays
                    let vars = this.variations;
                    let newVars = [];
                    let colorValueIdsUsed = []; // wenn id 5 oder 12 ist, valueIds reinschreiben
                    if(vars.length > 0){
                        for(let key in vars){
                            if(vars.hasOwnProperty(key) && vars[key].documents && vars[key].documents[0]){
                                for(let innerKey in vars[key].documents[0].data.attributes){
                                    if(vars[key].documents[0].data.attributes.hasOwnProperty(innerKey)){
                                        if([10, 2].indexOf(vars[key].documents[0].data.attributes[innerKey].attributeId) > -1){
                                            if(colorValueIdsUsed.indexOf(vars[key].documents[0].data.attributes[innerKey].valueId) < 0){
                                                newVars.push(vars[key]);
                                                colorValueIdsUsed.push(vars[key].documents[0].data.attributes[innerKey].valueId)
                                            }
                                        }
                                    }
                                }
                            }

                        }
                    }


                    this.variations = newVars;
                    this.$nextTick(() =>
                    {
                        this.initThumbSwiper();
                        this.isLoadingVariations = false;
                    });

                }).fail((err)=> console.log(err));
        },

        mouseOverThumbImage(event){ // $event.target
            let img = $(event).attr('image');
            $(event).closest('article').find('.thumb-image img').attr('src', img);
            $(event).closest('article').find('.thumb-image picture source').attr('srcset', img);
        },

        initThumbSwiper(){
            let swiperRef = this.$refs.thumbSwiper;
            let swiperOuterRef = this.$refs.thumbSwiperOuter;

            const swiper = new Swiper(swiperRef, {
                navigation: {
                    nextEl: $(swiperOuterRef).closest('.swiper-outer-container').find(".category-item__thumb-swiper-next")[0],
                    prevEl: $(swiperOuterRef).closest('.swiper-outer-container').find(".category-item__thumb-swiper-prev")[0]
                },
                lazy: true,
                slidesPerView: 5,
                spaceBetween: 3,
                loop: false,
                // centeredSlides: this.variations.length < 4,
                allowTouchMove: false
            });
        },
    }
}
</script>
